import type { UserStats } from '../types';
import type { ApiResponse } from '../types/api';
import httpClient from './http/httpClient';

export const getStats = async (): Promise<UserStats> => {
  const response = await httpClient.get<UserStats>('/getStats');
  return response;
};

export const submitFeedback = async (
  tenderId: string,
  feedback: string
): Promise<ApiResponse<{ message: string }>> => {
  const response = await httpClient.post<ApiResponse<{ message: string }>>('/submitFeedback', {
    tenderId,
    feedback,
  });
  return response;
};

// Upload support doc for tender using storage abstraction

export const reportError = async (params: {
  tenderId: string;
  error: string;
  component?: string;
}): Promise<ApiResponse<{ message: string }>> => {
  const response = await httpClient.post<ApiResponse<{ message: string }>>('/reportError', params);
  return response;
};

export const migrateSmartRag = async (params: {
  client_id: string;
}): Promise<ApiResponse<{ status: string; client_id: string }>> => {
  const response = await httpClient.post<ApiResponse<{ status: string; client_id: string }>>(
    '/migrateSmartRag',
    params
  );
  return response;
};

// Section-based Draft Generation
